<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-22 18:15:24
 * @FilePath: 
 * @Description: 预约挂号--选择时段页面
-->
<template>
  <div class="select_period_con">
    <div class="product_title">{{ projectInfo.Name }}</div>
    <ul class="day_list_con">
      <li
        v-for="(item, index) in dayList"
        :key="index"
        :class="curDayIndex == item.Date ? 'active' : ''"
        @click="handleSetDayType(item.Date)"
      >
        <div>
          {{ item.Name }}
        </div>
        <div class="date_con">
          {{ item.Date }}
        </div>
      </li>
    </ul>
    <ul class="period_list_con">
      <li
        v-for="(item, index) in periodList"
        :key="index"
        :class="{
          active: curPeriodIndex == item.Id,
          disabled: item.Remainder == 0,
        }"
        @click="handleSetPeriod(item.Id)"
      >
        <div>
          {{ item.Description }}
        </div>
        <div>
          {{ item.Remainder == 0 ? "约满" : "剩余：" + item.Remainder }}
        </div>
      </li>
    </ul>
    <div class="footer">
      <div class="title c-f-bt c-m-b-20" v-if="isNeedCheckNumber">
        <p>人数</p>
        <div class="add-box">
          <van-stepper
            :value="personNum"
            theme="round"
            button-size="22"
            min="0"
            disable-input
            :show-minus="personNum > 0"
            :show-input="personNum > 0"
            @change="(e) => handleChangeBookNum(e)"
          />
        </div>
      </div>
      <div class="submit_btn_con">
        <van-button color="var(--tc)" round block @click="handleSubmitOrder"
          >确定</van-button
        >
        <!-- <p class="dark-btn" @click="placeOrder"
      v-if="keyBindMode !== 'ManualInputByWaiter' || handCode">{{ wechatPointPayMode === 'CyBillWithPad' ? '呼叫服务员' : '提交订单' }}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { handleTimeLocalStorage } from "@/utils";
import { verifyWechatMember } from "@/utils/gFunc";
import { getPeriodsList, submitBookRegister } from "@/api/bookRegister";
export default {
  name: "SelectPeriod",
  props: {},
  data() {
    return {
      projectInfo: {
        Name: "",
      },
      canBookDay: 3,
      curDayIndex: "",
      curPeriodIndex: null,
      dayList: [],
      periodList: [],
      isNeedCheckNumber: false, //是否需要选择人数
      personNum: 1,
    };
  },
  components: {},
  created() {},
  mounted() {
    const pointProjectInfo = handleTimeLocalStorage.get("pointProject");
    this.projectInfo = pointProjectInfo;
    const bookConfigData = handleTimeLocalStorage.get("bookConfig");
    this.canBookDay = bookConfigData.BookingDaysInAdvance;
    this.isNeedCheckNumber = bookConfigData.BookingNumberOfPeople == 1;
    this.handelGetPeriods();
    // 根据可提前预约天数初始化可选日期
    for (let i = 0; i <= this.canBookDay; i++) {
      const dayInfo = this.getNextDate(i);
      this.dayList.push({
        Name: dayInfo.week,
        Date: dayInfo.date,
        ShowDate: dayInfo.date.slice(-2),
        YearDate: dayInfo.yearDate,
      });
    }
    this.curDayIndex = this.dayList[0].Date;
  },
  methods: {
    handelGetPeriods() {
      getPeriodsList({
        VpnId: this.$store.state.vpnId,
      }).then((res) => {
        this.allDateAndPeriodData = res;
        this.curDayIndex = res[0] ? res[0].Desc : "";
        this.periodList = res[0] ? res[0].TimeSpans : [];
      });
    },
    handleSetPeriodList() {
      const setPeriodItem = this.allDateAndPeriodData.find(
        (item) => item.Desc == this.curDayIndex
      );
      this.periodList = setPeriodItem.TimeSpans;
    },
    handleSetDayType(type) {
      this.curDayIndex = type;
      this.curPeriodIndex = null;
      this.handleSetPeriodList();
    },
    handleSetPeriod(type) {
      this.curPeriodIndex = type;
    },
    getNextDate(n) {
      // n为多少天，-代表往前，+代表往后
      let date1 = new Date(),
        time1 =
          date1.getFullYear() +
          "-" +
          (date1.getMonth() + 1) +
          "-" +
          date1.getDate(); //time1表示当前时间
      let date2 = new Date(date1);
      date2.setDate(date1.getDate() + n);
      let time2 =
        ("0" + (date2.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date2.getDate()).slice(-2);
      let yearDate = date2.getFullYear() + "-" + time2;
      let week = date2.getDay();
      const weekObj = {
        0: "日",
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六",
      };
      return { date: time2, week: weekObj[week], yearDate: yearDate };
    },
    handleChangeBookNum(val) {
      this.personNum = val;
    },
    handleSubmitOrder() {
      if (!this.curPeriodIndex) {
        return this.$toast("请选择时段！");
      }
      verifyWechatMember(() => {
        console.log("提交");
        //   const _this = this;

        const dayItem = this.dayList.find(
          (item) => item.Date == this.curDayIndex
        );
        const periodItem = this.periodList.find(
          (item) => item.Id == this.curPeriodIndex
        );
        handleTimeLocalStorage.set("pointProject", {
          ...this.projectInfo,
          NumberOfPeople: this.personNum,
          curPeriodIndex: this.curPeriodIndex,
          curPeriodName: periodItem.Description,
          yearDate: dayItem.YearDate,
        });
        this.$router.push({
          name: "BookRegisterOrderInfo",
          // query:{BookId:res}
        });
      });

      //       this.isSubmitLoading = true;
      //        const dayItem=this.dayList.find(item=>item.Date==this.curDayIndex)
      //       const requestData={
      //     "VpnId":this.$store.state.vpnId,
      //     "AccountId": 299828480,
      //     "GoodsId": this.projectInfo.Id,
      //     "JiShiId":this.projectInfo.JishiId,
      //     "TimeSpanId": this.curPeriodIndex,
      //     "Date":dayItem.yearDate
      // }
      //       submitBookRegister(requestData)
      //       .then((res) => {

      //       this.isSubmitLoading = false;

      // })
      // .catch(() => {
      //   this.isSubmitLoading = false;
      // });
    },
  },
};
</script>
<style scoped lang="scss">
.select_period_con {
  // padding: 24px 32px;
  .product_title {
    // text-align: center;
    padding: 30px 32px 0;
    font-weight: bold;
    color: #333;
    font-size: 30px;
    background-color: #fff;
  }
}
.day_list_con {
  background-color: #fff;
  display: flex;
  padding: 32px;
  overflow-x: auto;
  margin-bottom: 2px;
  li {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    flex-shrink: 0;
    margin-right: 48px;
    cursor: pointer;
    &.active {
      .date_con {
        background: #cca568;
      }
    }
    .date_con {
      height: 88px;
      width: 88px;
      border-radius: 50%;
      border: 1px solid #333333;
      color: #000;
      text-align: center;
      line-height: 88px;
      margin-top: 16px;
      font-size: 28px;
    }
  }
}
.period_list_con {
  display: flex;
  padding: 32px;
  background-color: #fff;
  flex-wrap: wrap;
  li {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 127px;
    width: 31.3%;
    flex-shrink: 0;
    margin-right: 12px;
    margin-bottom: 12px;
    background: #f7f7f7;

    border-radius: 8px;
    cursor: pointer;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &.active {
      background: #cca568;

      // border: 1rpx solid #CCA568;
      color: #fff;
    }
    &.disabled {
      color: rgba(51, 51, 51, 0.3);
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  // min-height: 140px;
  border-top: 1px solid #eee;
  background: #fff;
  box-sizing: border-box;
  padding: 26px 32px 26px;
  .submit_btn_con {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
